import React from 'react';
import { useSummaryStore } from '@src/stores/summaryStore';
import { Typography } from '@one-thd/sui-atomic-components';
import { dateFormat } from '@src/utils/general';
import ViewUPSBarcodeButton from '@src/components/view-ups-barcode/ViewUpsBarcodeButton';
import MultiAddressItems from './MultiAddressItems';
var MultiAddressBarcodes = function () {
    var shipments = useSummaryStore(function (state) { return state.shipments; });
    var returnByDate = useSummaryStore(function (state) { return state.returnByDate; });
    return (React.createElement("div", { "data-testid": "multi-address-barcodes", className: "sui-max-w-[350px]" }, shipments === null || shipments === void 0 ? void 0 : shipments.map(function (shipment, i) { return (React.createElement("div", { className: "sui-mb-[24px]", key: i },
        React.createElement(Typography, { variant: "body-base", weight: "bold" }, 'Return to UPS by ' + dateFormat(returnByDate, 'EEE, MMMM d')),
        React.createElement(MultiAddressItems, { shipment: shipment }),
        React.createElement(ViewUPSBarcodeButton, { shipment: shipment, variant: "secondary" }))); })));
};
export default MultiAddressBarcodes;
